import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    businessInterests: [],
  },
  mutations: {
    setBusinessInterests(state, businessInterests) {
      Vue.set(state, 'businessInterests', businessInterests);
    },
  },
  actions: {
    fetchBusinessInterests({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/business-interests`).then(response => {
        return commit('setBusinessInterests', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};